import { StandardButton } from '@/components/buttons';
import { WorkflowFooter } from '@/components/workflow/workflow-footer';
import { Button } from '@mantine/core';
import { IconBarcode } from '@tabler/icons-react';
import { AnimatePresence, motion } from 'motion/react';
import { useMemo } from 'react';
import { useBagAuditContext } from './hook';

export const BagAuditFooter = () => {
	const { page, showManualCodeEntry, setShowManualCodeEntry, handleSubmit, loadingSubmission } =
		useBagAuditContext();

	const footerContent: { actions: React.ReactNode; secondary?: React.ReactNode } | null =
		useMemo(() => {
			switch (page) {
				case 'SCAN':
					return {
						actions: (
							<Button
								size="lg"
								variant="filled"
								fullWidth
								style={{ fontSize: 18 }}
								onClick={() => setShowManualCodeEntry(true)}
								leftSection={<IconBarcode size={16} />}
							>
								Manual Code Entry
							</Button>
						),
					};
				case 'FORM':
					return {
						actions: (
							<StandardButton
								onClick={handleSubmit}
								loading={loadingSubmission}
								disabled={loadingSubmission}
							>
								Save Changes
							</StandardButton>
						),
					};
				default:
					return {
						actions: null,
					};
			}
		}, [page, handleSubmit, setShowManualCodeEntry, loadingSubmission]);

	const shouldHideFooter = useMemo(() => {
		if (showManualCodeEntry || page === 'PHOTOS') {
			return true;
		}
		return false;
	}, [showManualCodeEntry, page]);

	return (
		<AnimatePresence initial={false}>
			{!shouldHideFooter && (
				<motion.div
					initial={{ y: 150 }}
					animate={{
						y: 0,
						transition: {
							type: 'spring',
							damping: 25,
							stiffness: 300,
							mass: 0.8,
							delay: 0.1,
						},
					}}
					exit={{
						y: 150,
						transition: {
							type: 'spring',
							damping: 30,
							stiffness: 400,
							mass: 0.6,
							duration: 0.25,
						},
					}}
					style={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 1000 }}
				>
					<WorkflowFooter secondaryContent={footerContent?.secondary || null}>
						{footerContent.actions}
					</WorkflowFooter>
				</motion.div>
			)}
		</AnimatePresence>
	);
};
